import { FunctionComponent } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withApollo } from '@apollo/client/react/hoc';

import audioPlayerActions, {
  AudioPlayerActions,
} from '../../actions/audioPlayer';
import AudioPlayerTrigger, {
  AudioPlayerTriggerProps,
} from './AudioPlayerTrigger';

import { AudioPlayerState } from '../../reducers/audioPlayer';

interface AudioPlayerDispatchers {
  dispatchers: AudioPlayerActions;
}

const stateToProps = ({ audioPlayer }): { audioPlayer: AudioPlayerState } => {
  return { audioPlayer };
};

const dispatchToProps = (dispatch): AudioPlayerDispatchers => {
  return {
    dispatchers: bindActionCreators(audioPlayerActions, dispatch),
  };
};

export default compose(
  withApollo,
  connect(stateToProps, dispatchToProps)
)(AudioPlayerTrigger) as FunctionComponent<
  Pick<AudioPlayerTriggerProps, 'audioId'>
>;
